import React, { useEffect, useCallback, useState, useContext, useMemo } from "react";
import { debounce } from "lodash";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import APICall from "../../services/apiCall";
import AppContext from "../../context/Context";
import APIPortalTable from "../common/Table/APIPortalTable";
import apiCall from "../../services/apiCall";

let materialColumns = [
    {
        accessorKey: "email_id",
        header: "Email",
        csvFormatter: (cell, row, rowIndex) => {
            if (cell === "") {
                return "--";
            } else {
                return cell;
            }
        },
        csvExport: true,
        sort: true,
    },
    {
        accessorKey: "master_customer_id",
        header: "Master Customer ID",
        csvFormatter: (cell, row, rowIndex) => {
            if (cell === "") {
                return "--";
            } else {
                return cell;
            }
        },
        csvExport: true,
        sort: true,
    },
    {
        accessorKey: "first_name",
        header: "First Name",
        csvFormatter: (cell, row, rowIndex) => {
            if (cell === "") {
                return "--";
            } else {
                return cell;
            }
        },
        csvExport: true,
        sort: true,
    },
    {
        accessorKey: "last_name",
        header: "Last Name",
        csvFormatter: (cell, row, rowIndex) => {
            if (cell === "") {
                return "--";
            } else {
                return cell;
            }
        },
        csvExport: true,
        sort: true,
    },
    {
        accessorKey: "is_demo_practice",
        header: "Environment",
        csvFormatter: (cell, row, rowIndex) => {
            if (cell === "") {
                return "--";
            } else {
                return cell;
            }
        },
        csvExport: true,
        sort: true,
        Cell: ({ cell }) => <span>{cell.getValue() == "0" ? "P" : "Q"}</span>, //optional custom cell render
    },

];

const AddNewPaymentUpdateModal = ({
    noSearchCustomers,
    partnerCustomerListForLiveUpdate,
    rowSelection,
    setRowSelection,
    currentActiveLocation
}) => {
    const [searchCustomerValue, setSearchedCustomerValue] = useState("");
    const [searchedCustomers, setSearchedCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [rowSelection, setRowSelection] = useState({});
    function filterObjectArrayPartial(searchValue) {
        let tempArray = partnerCustomerListForLiveUpdate.filter(obj =>
            Object.values(obj).some(value =>
                value.toString().toLowerCase().includes(searchValue.toLowerCase())
            )
        );
        var demoPracticeFlag = "1";
        if (window.location.href.includes("api.sikkasoft.com")) {
            demoPracticeFlag = "0";
        }
        var TempArray = tempArray.filter((location) => {
            return location.opt_flag == 1 && location.is_demo_practice == demoPracticeFlag
        })
        var currentActiveLocationList = currentActiveLocation.map((x) => {
            return x.master_id
        })
        var finalArray = TempArray.filter((x) => {
            return !currentActiveLocationList.includes(x.master_customer_id)
        })
        setSearchedCustomers(finalArray)
    }
    const changeHandler = (event) => {
        const value = event?.target?.value;
        filterObjectArrayPartial(value)
        setSearchedCustomerValue(value);
    };
    useMemo(() => {

        var demoPracticeFlag = "1";
        if (window.location.href.includes("api.sikkasoft.com")) {
            demoPracticeFlag = "0";
        }
        var TempArray = partnerCustomerListForLiveUpdate.filter((location) => {
            return location.opt_flag == 1 && location.is_demo_practice == demoPracticeFlag
        })
        var currentActiveLocationList = currentActiveLocation.map((x) => {
            return x.master_id
        })
        var finalArray = TempArray.filter((x) => {
            return !currentActiveLocationList.includes(x.master_customer_id)
        })
        setSearchedCustomers([...finalArray])
    }, [])

    return (
        <div>
            <div className="mb-3">
                <Form.Group>
                    <Form.Control
                        required
                        type="text"
                        autoFocus={true}
                        placeholder="Search using email, first name, last name, master id, If customer already exist"
                        aria-label="Search"
                        className="rounded-pill search-input"
                        onChange={changeHandler}
                        onInput={() => {
                            setRowSelection({});
                        }}
                    />
                </Form.Group>
                {noSearchCustomers && (
                    <div className="d-flex justify-content-center" style={{ color: "#e63757" }}>
                        Please choose a practice.
                    </div>
                )}
            </div>

            <APIPortalTable
                data={searchedCustomers}
                columns={materialColumns}
                loading={loading}
                enablePagination
                CSVFileName={"Customer List.csv"}
                enableRowSelection={true}
                enableMultiRowSelection={true}
                getRowId={(row) => {
                    return row.master_customer_id
                }}
                onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                state={{ rowSelection }}
            />
        </div>
    );
};

export default AddNewPaymentUpdateModal;
